import React from 'react';

import { ApplicationHero } from '@/app/_components/ApplicationHero';
import { ApplicationHeroProps } from './types';

import classes from './index.module.scss';

export const ApplicationHeroGraphQL: React.FC<ApplicationHeroProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <ApplicationHero applicationHero={props} />
    </div>
  );
};

export default ApplicationHeroGraphQL;
